import * as React from "react";
import { useWorkflow } from "../../../../context/reports/workflow";
import { useActions } from "../../../../context/reports/workflow/useActions";

export function useWorkflowEffects() {
  const [
    state,
    // dispatch
  ] = useWorkflow();

  const { getSummary, getMetrics } = useActions();

  const requestSummary = React.useCallback(() => {
    void getSummary(
      state.metrics.currentMetricsType,
      state.sites,
      state.startDate,
      state.endDate
    );
  }, [
    state.metrics.currentMetricsType,
    state.sites,
    state.startDate,
    state.endDate,
  ]);

  const requestMetrics = React.useCallback(() => {
    void getMetrics(
      state.metrics.currentMetricsType,
      state.active,
      state.startDate,
      state.endDate
    );
  }, [
    state.metrics.currentMetricsType,
    state.active,
    state.startDate,
    state.endDate,
  ]);

  /**
   * Track initial load state
   * If either metrics or summary are still
   * loading, first load has not yet complete
   */
  const firstLoad = React.useRef(true);
  React.useEffect(() => {
    firstLoad.current = !state.summaryLoaded || !state.metricsLoaded;
  }, [state.summaryLoaded && state.metricsLoaded]);

  /**
   * Handle initial load requests
   * Wait for sites to exist in state and,
   * if summary/metrics aren't loaded, load em
   */
  React.useEffect(() => {
    // If no sites are loaded, skip
    if (state.sites.size === 0) return;

    if (!state.summaryLoaded && !state.summaryLoading) {
      requestSummary();
    }
    if (!state.metricsLoaded && !state.metricsLoading) {
      requestMetrics();
    }
  }, [state.summaryLoaded, state.metricsLoaded, state.sites]);

  /**
   * After initial load, wait for changes to
   * `shouldUpdateSummary` and `shouldUpdateMetrics`
   * and request when appropriate
   */
  React.useEffect(() => {
    if (state.sites.size === 0 || firstLoad.current) return;

    if (state.shouldUpdateSummary && !state.summaryLoading) {
      requestSummary();
    }
    if (state.shouldUpdateMetrics && !state.metricsLoading) {
      requestMetrics();
    }
  }, [
    state.summaryLoading,
    state.metricsLoading,
    state.shouldUpdateSummary,
    state.shouldUpdateMetrics,
  ]);
}
